import {
	AUTH_SUCCESS,
	CHANGE_PASSWORD,
	FETCH_TOKEN_INFO_FAILURE,
	FETCH_TOKEN_INFO_SUCCESS,
	LOGOUT,
	LOGOUT_FROM_ALL_DEVICES_FAILURE,
	LOGOUT_FROM_ALL_DEVICES_REQUEST,
	LOGOUT_FROM_ALL_DEVICES_SUCCESS,
	LOGOUT_FROM_ONE_DEVICES_FAILURE,
	LOGOUT_FROM_ONE_DEVICES_SUCCESS,
	SET_ID,
	SET_PARTNER,
	VERIFY_TOKEN_REQUEST,
	VERIFY_OTP_CODE,
	RESEND_OTP_CODE,
} from "app/actionTypes";
import Cookies from "js-cookie";
import axios from "app/utils/http/http";
import { default as axiosIns } from "axios";
import compact from "lodash/compact";
import { getCredentials, getTokenIdFromToken } from "app/utils/auth";
import { getStore } from "app/configureStore";
import { COOKIES_AUTH_EXPIRES, REGISTER_URL, SIGNUP_URL } from "app/constants";
import env from "app/utils/env";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { updateEmail } from "app/reducers/emailActionCreators";
import {
	AUTH_GOOGLE,
	LOGIN,
	LOGIN_WITH_BOOKING_REFERENCE,
	RESEND_CONFIRMATION_EMAIL,
	RESET_PASSWORD,
	SET_CAN_LOGIN_AT,
	SET_SESSION_BIID,
	SET_USER_BIID,
} from "app/pages/Auth/AuthActionTypes";
import { STORAGE_KEY_PREFIX } from "app/utils/persistor";
import { getDefaultPartnerForDomain, getDefaultPartnerForShop } from "app/reducers/brandSelector";
import { isServerSide } from "app/utils/utils";
import { resetParentSponsorId } from "../Account/Parrainage/sponsorActionCreators";

const CHANGE_URL = "/auth/local/change";
const AUTH_GOOGLE_URL = "/auth/google";
const LOGIN_URL = "/auth/local/login";
const RESET_PASSWORD_URL = "/auth/local/reset";
const RESEND_URL = "/auth/local/resend";
const DELETE_TOKEN_URL = "/token/delete";
const INFO_TOKEN_URL = "/token/info";

export const sponsorshipSubscribe = (parentSponsorId, email, token) => {
	return axios.post(
		env("SPONSORSHIP_API_URL") + "/sponsorship/subscribe",
		{
			sponsorId: parentSponsorId,
			sponsored: email,
		},
		{
			headers: {
				...(token && { Authorization: token }),
				"Content-type": "application/json",
			},
		}
	);
};

export const authWithGoogle = data => {
	return {
		type: AUTH_GOOGLE,
		promise: axios.post(AUTH_GOOGLE_URL, data, {
			baseURL: env("USER_AUTH_API_URL"),
			headers: {
				"Content-type": "text/plain",
			},
		}),
	};
};

export const login = data => {
	return {
		type: LOGIN,
		promise: axios.post(
			LOGIN_URL,
			{ credentials: data },
			{
				baseURL: env("USER_AUTH_API_URL"),
				headers: {
					"Content-type": "text/plain",
				},
			}
		),
	};
};

export const resetPassword = payload => {
	return {
		type: RESET_PASSWORD,
		promise: axios.post(RESET_PASSWORD_URL, payload, {
			baseURL: env("USER_AUTH_API_URL"),
			headers: {
				"Content-type": "text/plain",
			},
		}),
	};
};

export const changePassword = (payload, queryToken, track) => {
	// Dans le cas ou on est dans la page de profile, on aura pas de token dans la queyr
	// Dans le cas de la page de changePassword, le token se trouve dans la query
	const shop = getStore()?.getState()?.shop;

	const authorization = queryToken || getCredentials(shop)?.token || false;

	return {
		type: CHANGE_PASSWORD,
		promise: new Promise((resolve, reject) => {
			const { token } = getCredentials(shop);
			const tokenId = getTokenIdFromToken(token);

			if (token && tokenId) {
				// suppression du tokenId, fire and forget
				axios
					.post(
						`${DELETE_TOKEN_URL}`,
						{ token: token, delete: [tokenId] },
						{
							baseURL: env("USER_AUTH_API_URL"),
							headers: {
								"Content-type": "text/plain",
							},
						}
					)
					.catch(error => {
						let message;

						if (error.response && error.response) {
							message = `${error.response.status} - ${JSON.stringify(
								error.response.data
							)}`;
						} else {
							message = JSON.stringify(error);
						}

						track("token_delete_error", { error: message || "" });
					});
			}

			axiosIns
				.post(CHANGE_URL, payload, {
					baseURL: env("USER_AUTH_API_URL"),
					headers: {
						Authorization: authorization,
						"Content-type": "application/json",
					},
				})
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		}),
	};
};

export const changePasswordSecurely = (payload, track) => {
	return {
		type: CHANGE_PASSWORD,
		promise: new Promise((resolve, reject) => {
			const shop = getStore()?.getState()?.shop;
			const { token } = getCredentials(shop);
			const tokenId = getTokenIdFromToken(token);

			if (token && tokenId) {
				// suppression du tokenId, fire and forget
				axios
					.post(
						`${DELETE_TOKEN_URL}`,
						{ token: token, delete: [tokenId] },
						{
							baseURL: env("USER_AUTH_API_URL"),
							headers: {
								"Content-type": "text/plain",
							},
						}
					)
					.catch(error => {
						let message;

						if (error.response && error.response) {
							message = `${error.response.status} - ${JSON.stringify(
								error.response.data
							)}`;
						} else {
							message = JSON.stringify(error);
						}

						track("token_delete_error", { error: message || "" });
					});
			}

			axiosIns
				.post(
					`${LOGIN_URL}?changePassword=true`,
					{
						credentials: {
							email: payload.email,
							password: payload.actualPassword,
						},
					},
					{
						baseURL: env("USER_AUTH_API_URL"),
						headers: {
							"Content-type": "text/plain",
						},
					}
				)
				.then(res => {
					axiosIns
						.post(
							CHANGE_URL,
							{
								password: payload.password,
							},
							{
								baseURL: env("USER_AUTH_API_URL"),
								headers: {
									Authorization: res.data.token,
									"Content-type": "application/json",
								},
							}
						)
						.then(res => {
							resolve(res);
						});
				})
				.catch(err => {
					reject(err);
				});
		}),
	};
};

export const authSuccessForShop = ({ shop, partnerCode, token, uuid, email }) => {
	try {
		Cookies.set("auth", "auth", { expires: COOKIES_AUTH_EXPIRES, path: `/${shop}` });
		Cookies.set("partner", partnerCode, { path: `/${shop}` });
		// update the fsVisitorID cookie for flagship server side
		Cookies.set("fsVisitorID", uuid, { path: `/${shop}` });

		// redux-persist v6 stores the localStorage whitelist under a single "root" key,
		// where each slice value is itself JSON-stringified. We seed auth/email there so the
		// target shop rehydrates them on its next load (read-modify-write to keep other slices).
		const rootKey = `${STORAGE_KEY_PREFIX}:${shop}:root`;

		let persistedRoot = {};
		try {
			persistedRoot = JSON.parse(window.localStorage.getItem(rootKey)) || {};
		} catch (parseError) {
			persistedRoot = {};
		}

		persistedRoot.auth = JSON.stringify({ token, uuid });
		if (email) {
			persistedRoot.email = JSON.stringify(email);
		}
		persistedRoot._persist =
			persistedRoot._persist || JSON.stringify({ version: -1, rehydrated: true });

		window.localStorage.setItem(rootKey, JSON.stringify(persistedRoot));
	} catch (e) {
		console.error("cookies set", e); // eslint-disable-line no-console
	}
};

export const authSuccess = (res, isSignup) => {
	const shop = getStore()?.getState()?.shop;

	const uuid = res?.data?.uuid;

	try {
		Cookies.set("authToken", res?.data?.token, {
			expires: COOKIES_AUTH_EXPIRES,
			path: `/${shop}`,
		});
		Cookies.set("auth", "auth", { expires: COOKIES_AUTH_EXPIRES, path: `/${shop}` });
		Cookies.set("partner", res.data.partner.code, { path: `/${shop}` });
		// update the fsVisitorID cookie for flagship server side
		Cookies.set("fsVisitorID", uuid, { path: `/${shop}` });

		// les test e2e cypress fails sans ce code. @see https://github.com/cypress-io/cypress/issues/2193
		if (window.Cypress) {
			Cookies.set("auth", "auth", {
				expires: COOKIES_AUTH_EXPIRES,
				path: `/${shop}`,
				domain: ".perfectstay.io",
			});
			Cookies.set("partner", res.data.partner.code, {
				path: `/${shop}`,
				domain: ".perfectstay.io",
			});
		}
	} catch (e) {
		// TODO
		console.error("cookies set", e); // eslint-disable-line no-console
	}
	return {
		type: AUTH_SUCCESS,
		isSignup,
		uuid,
		token: res.data.token, // TODO Quand on se loggue via le bloc membership, ca empeche le scroll de revenir sur le bloc membership. A regarder quand FBR-2575 sera en prod
		email: res.data.email,
		partner: res.data.partner,
		partners: getStore().getState().partners,
	};
};

/**
 * Verifie si le token passé en parametre contient un tokenId. En renvoie un nouveau avec tokenId si ce n'est pas le cas
 * @param token
 * @param dispatch
 * @returns {Promise}
 */
export const getCredentialsWithTokenId = (token, track) => {
	return (dispatch, getState) => {
		return new Promise(resolve => {
			const tokenId = getTokenIdFromToken(token);
			const shop = getState()?.shop;

			if (tokenId) {
				track("token_renew_bypassed");
				resolve(token);
			} else if (token) {
				axios
					.post(
						"/token/renew",
						{ token: token },
						{
							baseURL: env("USER_AUTH_API_URL"),
							headers: {
								"Content-type": "text/plain",
							},
						}
					)
					.then(res => {
						const tokenWithTokenId = res.data.token;

						Cookies.set("authToken", tokenWithTokenId, {
							expires: COOKIES_AUTH_EXPIRES,
							path: `/${shop}`,
						});

						track("token_renew_success");

						resolve(tokenWithTokenId);
					})
					.catch(error => {
						let message;

						if (error.response && error.response) {
							message = `${error.response.status} - ${JSON.stringify(
								error.response.data
							)}`;
						} else {
							message = JSON.stringify(error);
						}

						track("token_renew_error", { error: message || "" });
					});
			}
		});
	};
};

export const getTokenInfo = () => {
	return dispatch => {
		const shop = getStore()?.getState()?.shop;
		const { token } = getCredentials(shop);

		return new Promise((resolve, reject) => {
			axios
				.post(
					`${INFO_TOKEN_URL}`,
					{ token: token },
					{
						baseURL: env("USER_AUTH_API_URL"),
						headers: {
							"Content-type": "text/plain",
						},
					}
				)
				.then(res => {
					const tokenInfos = res.data;

					dispatch({
						type: FETCH_TOKEN_INFO_SUCCESS,
						tokenInfos,
					});

					resolve(tokenInfos);
				})
				.catch(error => {
					dispatch({
						type: FETCH_TOKEN_INFO_FAILURE,
					});

					reject(error);
				});
		});
	};
};

export const logoutFromDevice = tokenId => {
	return (dispatch, getState) => {
		const shop = getStore()?.getState()?.shop;
		const { token } = getCredentials(shop);
		return new Promise((resolve, reject) => {
			return axios
				.post(
					`${DELETE_TOKEN_URL}`,
					{ token: token, delete: [tokenId] },
					{
						baseURL: env("USER_AUTH_API_URL"),
						headers: {
							"Content-type": "text/plain",
						},
					}
				)
				.then(res => {
					const tokenInfos = res.data;
					const { token } = getCredentials(shop);
					const actualTokenId = getTokenIdFromToken(token);

					dispatch({
						type: LOGOUT_FROM_ONE_DEVICES_SUCCESS,
						tokenInfos,
					});

					if (actualTokenId === tokenId) {
						const shop = getState()?.shop;
						try {
							Cookies.remove("auth", { path: `/${shop}` });
							Cookies.remove("authToken", { path: `/${shop}` });
						} catch (e) {
							console.error("cookies set", e); // eslint-disable-line no-console
						} finally {
							dispatch({
								type: LOGOUT,
							});
						}
					}

					resolve(tokenInfos);
				})
				.catch(() => {
					dispatch({
						type: LOGOUT_FROM_ONE_DEVICES_FAILURE,
					});

					reject();
				});
		});
	};
};

export const logoutFromAllDevices = () => {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			const tokenIds = compact(
				getState().auth.tokenInfos.map(tokenInfo => tokenInfo.tokenId)
			);
			const { token } = getCredentials(getState()?.shop);

			dispatch({
				type: LOGOUT_FROM_ALL_DEVICES_REQUEST,
			});

			return axios
				.post(
					`${DELETE_TOKEN_URL}`,
					{ token: token, delete: tokenIds },
					{
						baseURL: env("USER_AUTH_API_URL"),
						headers: {
							"Content-type": "text/plain",
						},
					}
				)
				.then(() => {
					const shop = getState()?.shop;

					try {
						Cookies.remove("auth", { path: `/${shop}` });
						Cookies.remove("authToken", { path: `/${shop}` });
					} catch (e) {
						console.error("cookies set", e); // eslint-disable-line no-console
					} finally {
						dispatch({
							type: LOGOUT,
						});

						dispatch({
							type: LOGOUT_FROM_ALL_DEVICES_SUCCESS,
						});

						resolve();
					}
				})
				.catch(() => {
					dispatch({
						type: LOGOUT_FROM_ALL_DEVICES_FAILURE,
					});

					reject();
				});
		});
	};
};

export const logoutUser = shop => {
	try {
		Cookies.remove("auth", { path: `/${shop}` });
		Cookies.remove("authToken", { path: `/${shop}` });
		return {
			type: LOGOUT,
		};
	} catch (e) {
		// TODO
		console.error("cookies set", e); // eslint-disable-line no-console
		return {
			type: LOGOUT,
		};
	}
};

export const logout = ({ track }) => {
	return (dispatch, getState) => {
		const { token } = getCredentials();
		const shop = getState().shop;

		const domain = window?.location?.origin;

		const tokenId = getTokenIdFromToken(token);

		track("logout");

		if (token && tokenId) {
			// suppression du tokenId, fire and forget
			axios
				.post(
					`${DELETE_TOKEN_URL}`,
					{ token: token, delete: [tokenId] },
					{
						baseURL: env("USER_AUTH_API_URL"),
						headers: {
							"Content-type": "text/plain",
						},
					}
				)
				.then(() => {
					Cookies.remove("auth", { path: `/${shop}` });
					Cookies.remove("authToken", { path: `/${shop}` });
				})
				.catch(error => {
					let message;

					if (error.response && error.response) {
						message = `${error.response.status} - ${JSON.stringify(
							error.response.data
						)}`;
					} else {
						message = JSON.stringify(error);
					}

					track("token_delete_error", { error: message || "" });
				});
		}

		const partnerToApply = !domain?.includes("localhost")
			? getDefaultPartnerForDomain(domain)(getState())
			: getDefaultPartnerForShop(getState());

		const partnerCodeToApply = partnerToApply?.code;

		if (
			!isServerSide &&
			window.FB?.getAccessToken() &&
			typeof window.FB?.logout === "function"
		) {
			window.FB.logout(response => {
				if (response?.status === "unknown") {
					track("facebook_logout");
				}
			});
		}

		try {
			Cookies.remove("auth", { path: `/${shop}` });
			Cookies.remove("authToken", { path: `/${shop}` });
			Cookies.set("partner", partnerCodeToApply, { path: `/${shop}` });

			// les test e2e cypress fails sans ce code. @see https://github.com/cypress-io/cypress/issues/2193
			if (!isServerSide && window.Cypress) {
				Cookies.remove("auth", { path: `/${shop}`, domain: ".perfectstay.io" });
				Cookies.remove("authToken", { path: `/${shop}`, domain: ".perfectstay.io" });
				Cookies.set("partner", partnerCodeToApply, {
					path: `/${shop}`,
					domain: ".perfectstay.io",
				});
			}
		} catch (e) {
			// TODO
			console.error("cookies set", e); // eslint-disable-line no-console
		} finally {
			dispatch({
				type: SET_PARTNER,
				partner: partnerCodeToApply,
				strategy: partnerToApply?.strategy,
				partners: getState().partners,
			});

			dispatch({
				type: LOGOUT,
			});
		}
	};
};

export const setTokenFromPartner = tokenFromPartner => {
	const shop = getStore()?.getState()?.shop;
	Cookies.set("tokenFromPartner", tokenFromPartner, {
		expires: COOKIES_AUTH_EXPIRES,
		path: `/${shop}`,
	});
};

export const updateAuthToken = ({ authToken, shop }) => {
	try {
		Cookies.set("authToken", authToken, {
			expires: COOKIES_AUTH_EXPIRES,
			path: `/${shop}`,
		});
		Cookies.set("auth", "auth", { expires: COOKIES_AUTH_EXPIRES, path: `/${shop}` });
	} catch (error) {
		console.error("cookies set", error); // eslint-disable-line no-console
	}
};

export const thunkSetId = (uuid, track) => {
	return (dispatch, getState) => {
		const actuelUuid = getState().auth.uuid;
		const shop = getState()?.shop;

		if (actuelUuid && actuelUuid !== uuid) {
			dispatch(logout({ track }));
		} else if (Cookies.get("auth", { path: `/${shop}` }) !== "auth") {
			try {
				Cookies.set("auth", "identified", {
					expires: COOKIES_AUTH_EXPIRES,
					path: `/${shop}`,
				});

				// les test e2e cypress fails sans ce code. @see https://github.com/cypress-io/cypress/issues/2193
				if (window.Cypress) {
					Cookies.set("auth", "identified", {
						expires: COOKIES_AUTH_EXPIRES,
						path: `/${shop}`,
						domain: ".perfectstay.io",
					});
				}
			} catch (e) {
				console.error("cookies set", e); // eslint-disable-line no-console
			}
		}

		dispatch({
			type: SET_ID,
			uuid,
		});
	};
};

export const signupPromise = ({
	data,
	navigate,
	partner,
	source,
	parentSponsorId,
	onAuthSuccess,
	dispatch,
	formHandle,
	track,
}) => {
	const { setErrors, setSubmitting } = formHandle;
	return new Promise((resolve, reject) => {
		return axios
			.post(
				SIGNUP_URL,
				{
					credentials: {
						email: data.email,
						password: data.password,
					},
					...(data.terms && { terms: data.terms }),
					...(typeof data.newsletter === "boolean" && { newsletter: data.newsletter }),
					...(!isEmpty(partner) && { partner: { code: partner?.code } }),
					source,
				},
				{
					baseURL: env("USER_AUTH_API_URL"),
					headers: { "Content-type": "text/plain" },
				}
			)
			.then(success => {
				return { success, isSignup: true };
			})
			.then(({ success }) => {
				if (parentSponsorId && partner.enableSponsorship) {
					sponsorshipSubscribe(parentSponsorId, data.email, success.data.token)
						.then(() => {
							track("sponsorship_subscribe_success", {
								sponsorid: parentSponsorId,
								email: data.email,
							});
							return { success, isSignup: true };
						})
						.catch(err => {
							track("sponsorship_subscribe_failed", {
								status: err.response.data.status || err.response.status,
								email: data.email,
							});
							return { success, isSignup: true };
						})
						.finally(() => {
							dispatch(resetParentSponsorId());
						});
				}

				return { success, isSignup: true };
			})
			.catch(error => {
				if (error.response.status === 403) {
					return axios
						.post(
							LOGIN_URL,
							{ credentials: data },
							{
								baseURL: env("USER_AUTH_API_URL"),
								headers: { "Content-type": "text/plain" },
							}
						)
						.then(success => {
							return { success, isSignup: false };
						});
				}
				throw error;
			})
			.then(({ success, isSignup }) => {
				dispatch(authSuccess(success, isSignup));

				if (onAuthSuccess && typeof onAuthSuccess === "function") {
					onAuthSuccess(success);
				} else {
					navigate("/listing"); // TODO pour le cas /home/signup continue de fonctionner. A refactorer en utilisant authSuccess
				}

				if (isSignup) {
					track("email_signup", { user: { type: "member" } });
				} else {
					track("email_signin");
				}

				resolve();
			})
			.catch(error => {
				if (Object.prototype.hasOwnProperty.call(error, "_error")) {
					track("email_signup_error", { status: "", error: error._error.id });
					track("error", { error: error._error.id });
					setSubmitting(false);
					setErrors({ _error: { id: error._error.id } });
					reject(error);
				}

				let _error = { id: "error.generic" };

				if (
					error.response &&
					(error.response.status === 403 || error.response.status === 401)
				) {
					_error = { id: "error.email.not.available" };
				}

				track("email_signup_error", {
					status: error.response && error.response.status,
					error: _error.id,
				});
				setSubmitting(false);
				setErrors({ _error: _error });
				reject({ _error });
			});
	});
};

export const registerPromise = ({
	data,
	partner,
	navigate,
	dispatch,
	shop,
	onAuthSuccess,
	formHandle,
	track,
}) => {
	const { setErrors, setSubmitting } = formHandle;
	return new Promise((resolve, reject) => {
		return axios
			.post(
				REGISTER_URL,

				{
					credentials: {
						email: data.email,
						password: data.password,
					},
					...(data.terms && { terms: data.terms }),
					...(typeof data.newsletter === "boolean" && { newsletter: data.newsletter }),
					...(!isEmpty(partner) && { partner: { code: partner?.code } }),
					redirect: `${env("BASE_URL")}/${shop}/confirmRegistration`,
				},
				{
					baseURL: env("USER_AUTH_API_URL"),
					headers: { "Content-type": "text/plain" },
				}
			)
			.then(() => {
				dispatch(updateEmail(data.email));
				// on n'envoie le tag qu'une seule fois (lorsqu'il s'inscrit la première fois)
				track("email_signup", { user: { type: "member" } });

				navigate("./registration-succeeded");
			})
			.catch(error => {
				if (error.response.status === 403) {
					/**
					 * présent base user (registered + confirmed)
					 * teasing : affichage date ouverture vente
					 * post-teasing:redirection listing
					 **/
					const today = new Date();
					const teasingEndDate = new Date(get(partner, "teasingEndDate"));
					if (today > teasingEndDate) {
						return axios
							.post(
								LOGIN_URL,
								{ credentials: data },
								{
									baseURL: env("USER_AUTH_API_URL"),
									headers: { "Content-type": "text/plain" },
								}
							)
							.then(res => {
								dispatch(authSuccess(res));

								if (onAuthSuccess && typeof onAuthSuccess === "function") {
									onAuthSuccess(res);
								}
								// on n'envoie le tag qu'une seule fois (lorsque les ventes seront ouvertes seulement)
								track("email_signin");
								navigate(`/listing?uuid=${res.data.uuid}`);
							})
							.catch(error => {
								if (Object.prototype.hasOwnProperty.call(error, "_error")) {
									track("error", { error: error._error.id });
									reject(error);
								}

								let _error = { id: "error.generic" };

								if (
									error.response &&
									(error.response.status === 403 || error.response.status === 401)
								) {
									_error = { id: "error.email.not.available" };
								}

								setSubmitting(false);
								setErrors({ _error: _error });
								track("error", { error: _error.id });
								reject({ _error });
							});
					}

					navigate("./registration-confirmed");
				} else if (error.response.status === 409) {
					/**
					 * présent base optin (registered + not confirmed)
					 * reste sur la page mais affiche message avec renvoi de mail
					 */

					dispatch(updateEmail(data.email));

					navigate("./registration-not-confirmed");
				}
				throw error;
			});
	});
};

export const resendConfirmationMail = ({ email, shop }) => {
	return {
		type: RESEND_CONFIRMATION_EMAIL,
		promise: axios.post(
			RESEND_URL,
			{ email, redirect: `${env("BASE_URL")}/${shop}/confirmRegistration` },
			{
				baseURL: env("USER_AUTH_API_URL"),
				headers: { "Content-type": "text/plain" },
			}
		),
	};
};

export const loginWithBookingReference = payload => {
	return {
		type: LOGIN_WITH_BOOKING_REFERENCE,
		promise: axios.post(
			"/auth/local/login",
			{ credentials: payload },
			{
				baseURL: env("USER_AUTH_API_URL"),
				headers: {
					"Content-type": "text/plain",
				},
			}
		),
	};
};

export const setUserBiid = userBiid => {
	return {
		type: SET_USER_BIID,
		userBiid,
	};
};

export const setSessionBiid = (sessionBiid, sessionBiidExpirationDate) => {
	return {
		type: SET_SESSION_BIID,
		sessionBiid,
		sessionBiidExpirationDate,
	};
};

export const setCanLoginAt = canLoginAt => {
	return {
		type: SET_CAN_LOGIN_AT,
		canLoginAt,
	};
};

export const verifyToken = token => {
	return {
		type: VERIFY_TOKEN_REQUEST,
		promise: axios.post(
			"/token/verify",
			{ token: token },
			{
				baseURL: env("USER_AUTH_API_URL"),
				headers: {
					"Content-type": "text/plain",
				},
			}
		),
	};
};

export const verifyOTPCode = ({ code, token }) => {
	const url = `${env("USER_AUTH_API_URL")}/auth/otp/verify`;
	const headers = {
		"Content-type": "application/json",
		Authorization: token,
	};
	return {
		type: VERIFY_OTP_CODE,
		promise: axiosIns.post(url, { code }, { headers }),
	};
};

export const sendOTPCode = ({ token }) => {
	const url = `${env("USER_AUTH_API_URL")}/auth/otp/send`;
	const headers = {
		"Content-type": "application/json",
		Authorization: token,
	};
	return {
		type: RESEND_OTP_CODE,
		promise: axiosIns.post(url, {}, { headers }),
	};
};
